import React, { Component } from 'react';
import RegexUtils from '../../../utils/RegexUtils';
import _ from 'lodash';

class TagItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      displayDelTag: false,
    };
  }

  onKeyPress = (event) => {
    if (!RegexUtils.isValid(event.key, RegexUtils.regexes.customTag)) {
      event.preventDefault();
    }
    event.target.value.length === 0
      ? this.setState({ displayDelTag: false })
      : this.setState({ displayDelTag: true });
    this.props.handleChangeOfTag(event);
  };
  onFocus = (event) => {
    event.target.value.length === 0
      ? this.setState({ displayDelTag: false })
      : this.setState({ displayDelTag: true });
  };
  onBlur = () => {
    this.props.editTagInput(this.props.mytag.key, this.refs.userTag.value);
    setTimeout(() => {
      this.setState({ displayDelTag: false });
    }, 150);
  };
  onPaste = (event) => {
    event.preventDefault();
  };
  assignTag = () => {
    this.props.assignTag(this.props.mytag);
  };
  deleteTag = () => {
    this.props.deleteTag(this.props.itemKey);
  };
  clearTag = () => {
    const event = { target: { value: '' } };
    this.refs.userTag.value = '';
    this.setState({ displayDelTag: false });
    this.props.handleChangeOfTag(event);
  };

  render() {
    let activeCssClass = '';
    _.map(this.props.cssActiveClassForSelectedTags, (rowTagId) => {
      if (rowTagId === this.props.mytag.key.toString()) {
        activeCssClass = 'active';
      }
    });
    return (
      <div className="edit-tag">
        {!this.props.flagForEditTag && !this.props.flagForAddTag ? (
          <span
            onClick={this.assignTag}
            className={`icon icon-tag ${activeCssClass} ${this.props.getClass(
              this.props.mytag.id
            )}`}
          >
            <span>{this.props.mytag.value}</span>
          </span>
        ) : (
          <div className="input-tag">
            <span
              className={`icon icon-tag ${this.props.getClass(
                this.props.mytag.value
              )}`}
            />
            <input
              onPaste={this.onPaste}
              onBlur={this.onBlur}
              onFocus={this.onFocus}
              maxLength={16}
              className={`${this.props.getClass(this.props.mytag.value)}`}
              type="text"
              ref="userTag"
              disabled={!this.props.flagForEditTag && !this.props.flagForAddTag}
              id={this.props.mytag.id}
              defaultValue={this.props.mytag.value}
              style={{ border: 'none' }}
              onChange={this.props.handleChangeOfTag}
              onKeyPress={this.onKeyPress}
              onKeyUp={this.onKeyPress}
              pattern={RegexUtils.regexes.customTag}
            />
            <a
              onClick={this.clearTag}
              className="searchClear"
              style={{
                display: `${this.state.displayDelTag ? 'block' : 'none'}`,
              }}
            >
              <span className="icon icon-clear" />
            </a>
            <a className="float-right" onClick={this.deleteTag}>
              Delete
            </a>
          </div>
        )}
      </div>
    );
  }
}

export { TagItem };
